function initDevicesPreview() {
  class DevicesPreview {
    constructor() {
      this.currentSlideIndex = 0;
      this.slideImages = document.querySelectorAll('.bb-devices-preview__device-content-img');
      this.gameInfoElements = document.querySelectorAll('.bb-devices-preview__game-info');
      this.bullets = document.querySelectorAll('.bb-devices-preview__bullet');
      this.prevBtn = document.querySelector('.bb-devices-preview__nav--prev');
      this.nextBtn = document.querySelector('.bb-devices-preview__nav--next');
      this.totalSlides = this.bullets.length;

      if (this.totalSlides > 0) {
        this.initEvents();
        this.showSlide(0);
      }
    }

    initEvents() {
      this.bullets.forEach((bullet, index) => {
        bullet.addEventListener('click', () => {
          this.showSlide(index);
        });
      });

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.showPrevSlide();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.showNextSlide();
        });
      }
    }

    showSlide(index) {
      if (index < 0 || index >= this.totalSlides) return;

      this.currentSlideIndex = index;

      this.slideImages.forEach((img) => {
        const slideIndex = parseInt(img.dataset.slideIndex);
        if (slideIndex === index) {
          img.classList.add('active');
        } else {
          img.classList.remove('active');
        }
      });

      this.gameInfoElements.forEach((info) => {
        const infoIndex = parseInt(info.dataset.slideIndex);
        if (infoIndex === index) {
          info.classList.add('active');
        } else {
          info.classList.remove('active');
        }
      });

      this.bullets.forEach((bullet, i) => {
        if (i === index) {
          bullet.classList.add('bb-devices-preview__bullet--active');
        } else {
          bullet.classList.remove('bb-devices-preview__bullet--active');
        }
      });
    }

    showNextSlide() {
      let nextIndex = this.currentSlideIndex + 1;
      if (nextIndex >= this.totalSlides) {
        nextIndex = 0;
      }
      this.showSlide(nextIndex);
    }

    showPrevSlide() {
      let prevIndex = this.currentSlideIndex - 1;
      if (prevIndex < 0) {
        prevIndex = this.totalSlides - 1;
      }
      this.showSlide(prevIndex);
    }
  }

  if (document.querySelector('.bb-devices-preview')) {
    new DevicesPreview();
  }
}

document.addEventListener('DOMContentLoaded', initDevicesPreview);
